import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon2 from "../assets/img/Shape.svg";
import Icon3 from "../assets/img/iconsax-export-arrow-01.svg";

const StudioPageContact = () => {
  const form = useRef(null);
  const [isSending, setIsSending] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    try {
      const fd = new FormData(form.current);

      
      const response = await fetch("https://workdayz.in/studiocontact.php", {
        method: "POST",
        body: fd,
      });

      const result = await response.json();
      console.log("PHP Response:", result);

      if (result?.success) {
        navigate("/thank-you");
      } else {
        alert("Database save failed: " + (result?.message || "Unknown error"));
      }
    } catch (err) {
      console.error("Submit Error:", err);
      alert("Something went wrong.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <form ref={form} onSubmit={handleSubmit} encType="multipart/form-data">
      <label htmlFor="name">Name</label><br />
      <input
        type="text"
        id="name"
        name="name"
        placeholder="Full Name"
        required
      />
      <br />

      <label htmlFor="number">Number</label><br />
      <input
        type="number"
        id="number"
        name="number"
        placeholder="Your Number"
        required
      />
      <br />

      <label htmlFor="email">Email</label><br />
      <input
        type="email"
        id="email"
        name="email"
        placeholder="Your Email"
        required
      />
      <br />

      <div className="row">
        <div className="upload">
          <div className="col-sm-6 upload_ins">
            <h3>Upload Inspiration</h3>
          </div>
          <div className="col-sm-6" style={{textAlign: 'right'}}>
           <div className="upload-wrap">
          <input
            type="file"
            id="upload-input"
            name="inspirations[]"
            accept="image/*,application/pdf"
            className="upload-input"
          />
          <label htmlFor="upload-input" className="upload-btn">
            <img src={Icon3}></img>
            <span>Upload</span>
          </label>
        </div>

          </div>
        </div>
      </div>

      <div data-animate="bottom" className="animeslide-desc submit_btn">
        <button type="submit" disabled={isSending} style={{margin: '0'}}>
          {isSending ? (
            <>
              <span className="spinner"></span>
              <span>Sending...</span>
            </>
          ) : (
            <>
              <img src={Icon2} alt="" />
              <span>Submit</span>
            </>
          )}
        </button>
      </div>
    </form>
  );
};

export default StudioPageContact;
